"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * HtmlCell - Composant pour afficher du HTML avec support CSS et JavaScript
 * Utilise une iframe pour garantir l'exécution du JS et l'isolation du CSS
 * 
 * @param {Object} props
 * @param {string} props.html - Contenu HTML à afficher (peut inclure <style> et <script>)
 * @param {Object} [props.styles_properties] - Propriétés de style
 * @param {string} [props.className] - Classes CSS additionnelles
 * @param {Object} [props.style] - Styles inline additionnels
 */const HtmlCell = ({
  html,
  styles_properties = {},
  className = '',
  style = {},
  scaleFactor = 1,
  ...rest
}) => {
  // Styles du conteneur
  const containerStyle = {
    backgroundColor: styles_properties.background_color,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius * scaleFactor}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width * scaleFactor}px` : undefined,
    borderStyle: styles_properties.border_style,
    padding: styles_properties.padding ? `${styles_properties.padding * scaleFactor}px` : undefined,
    opacity: styles_properties.opacity,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    ...style
  };

  // Générer le HTML complet pour l'iframe
  const fullHtml = (0, _react.useMemo)(() => {
    if (!html) return '';

    // Si le HTML contient déjà <!DOCTYPE> ou <html>, l'utiliser tel quel
    if (/<!DOCTYPE|<html[\s>]/i.test(html)) {
      return html;
    }

    // Sinon, envelopper dans un document HTML complet
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { 
      font-family: ${styles_properties.text_font || 'system-ui, -apple-system, sans-serif'}; 
      font-size: ${styles_properties.text_size ? `${styles_properties.text_size * scaleFactor}px` : '16px'};
      color: ${styles_properties.text_color || '#000000'};
      background: ${styles_properties.background_color || 'transparent'};
      text-align: ${styles_properties.text_align || 'left'};
    }
  </style>
</head>
<body>
${html}
</body>
</html>`;
  }, [html, styles_properties, scaleFactor]);
  const containerClasses = ['html-cell', className].filter(Boolean).join(' ');

  // Toujours utiliser une iframe pour garantir l'exécution du JS et l'isolation du CSS
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: containerClasses,
    style: containerStyle,
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
      srcDoc: fullHtml,
      title: "HTML Content",
      sandbox: "allow-scripts allow-same-origin allow-forms",
      style: {
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
        background: 'transparent'
      }
    })
  });
};
var _default = exports.default = HtmlCell;